const COLORS = {
  backgroundColor: '#1D1621',
  white: '#FCFCFC',
  black: 'black',
  gold: '#E7A23B',
  paragraphText: '#D2D0D3'
}

export default COLORS
